import React from 'react';
import { Drawer as CDrawer, Space, Button } from 'antd';
import { mapModifiers } from '@/utils/funtion';

interface IDrawerProps {
  children?: React.ReactNode;
  open: boolean;
  loading?: boolean;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  onClose?: () => void;
  onSubmit?: () => void;
  width?: number | string;
  title?: string | React.ReactNode;
  extra?: React.ReactNode;
  className?: string;
  textCancel?: string;
  textSubmit?: string;
  isHiddenSubmitBtn?: boolean;
  footer?: boolean;
}

const Drawer: React.FC<IDrawerProps> = ({
  children,
  placement,
  open,
  onClose,
  onSubmit,
  loading,
  width = 400,
  title,
  className,
  textCancel = 'Hủy',
  textSubmit = 'Gửi',
  isHiddenSubmitBtn = false,
  footer = true,
  extra,
}) => (
  <CDrawer
    title={title}
    placement={placement}
    width={width}
    onClose={onClose}
    open={open}
    loading={loading}
    className={mapModifiers('o-drawer', className, !footer && 'hide-footer')}
    size="default"
    footer={
      footer ? (
        <Space
          className={mapModifiers(
            'o-drawer_space',
            isHiddenSubmitBtn && 'hidden',
          )}
        >
          <Button className="o-drawer_close" aria-label="Hủy" onClick={onClose}>
            {textCancel}
          </Button>
          {!isHiddenSubmitBtn && (
            <Button
              type="primary"
              onClick={onSubmit}
              aria-label="Lưu thông tin"
            >
              {textSubmit}
            </Button>
          )}
        </Space>
      ) : null
    }
    extra={extra}
  >
    {children}
  </CDrawer>
);

export default Drawer;
